import { Button, Grid, Paper } from "@mui/material";
import { CustomCkeditor } from "components/CustomCkeditor";
import EditFormControl from "components/form/EditFormControl";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { createPie } from "models/piesModel";
import { useSnackbar } from "notistack";
import { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import CreateFlavourForm from "./CreateFlavourForm";

export default function FlavourAddComponent() {
  const formRef = useRef();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});

  const handleAdd = () => {
    const submitData = formRef.current?.prepare();
    if (submitData) {
      openLoading(true);
      createPie({
        data: submitData,
        onFinish: (res, err) => {
          openLoading(false);
          if (res === false) {
            if (!res && err?.message) {
              enqueueSnackbar(err?.message, { variant: "warning" });
            } else {
              enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
            }
            return;
          }
          enqueueSnackbar("Successfully Saved in", { variant: "success" });
          history.push("/flavours");
        },
      });
    }
  };
  return (
    <div>
      <Paper>
        <div className="p-4 flex justify-between items-center border-b border-white-gray">
          <CustomText variant="h6" bold={600}>
            Add new Flavour
          </CustomText>
        </div>
        <div className="p-4">
          <Grid container spacing={2} alignContent="stretch">
            <Grid item lg={4} md={4} sm={12} xs={12}>
              <div className="flex items-center justify-center h-full rounded bg-upload-file">
                <EditFormControl
                  className="w-full"
                  data={data}
                  name="image"
                  type="file"
                  size="small"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>
            </Grid>
            <Grid item lg={8} md={8} sm={12} xs={12}>
              <CreateFlavourForm data={data} ref={formRef} onChange={setData} />
              <CustomText className="pt-3 pb-2 text-sm" color="light-gray" bold>
                Description
              </CustomText>
              <CustomCkeditor
                value={data?.description ?? ""}
                onChange={(e) =>
                  setData((prev) => ({ ...prev, description: e.target.value }))
                }
              />
            </Grid>
          </Grid>
        </div>
      </Paper>
      <div className="flex items-center my-4">
        <Button variant="contained" color="secondary" onClick={handleAdd}>
          Add Flavour
        </Button>
        <Button
          className="mx-2"
          variant="outlined"
          color="secondary"
          onClick={() => history.push("/flavours")}
        >
          CANCEL
        </Button>
      </div>
    </div>
  );
}
